import React from 'react';
import DataEntryModal from '@grnhse/seedling/lib/birch/components/modals/data_entry_modal';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { SecondaryButton } from '@grnhse/seedling/lib/birch/components/buttons';
import { PrimaryButton } from '@grnhse/seedling/lib/birch/components/buttons';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('talent_matching.bulk_actions.send_email');

interface ModalFooterProps {
  closeModal: () => void;
  disableButtons: boolean;
}

const ModalFooter = ({ closeModal, disableButtons }: ModalFooterProps) => {
  return (
    <DataEntryModal.Footer>
      <Stack direction="row" spacing={2}>
        <SecondaryButton onClick={closeModal} disabled={disableButtons}>
          {t('cancel')}
        </SecondaryButton>
        <PrimaryButton type="submit" disabled={disableButtons}>
          {t('confirm')}
        </PrimaryButton>
      </Stack>
    </DataEntryModal.Footer>
  );
};

export default ModalFooter;
